export class ExtraWorkDaysModel {

    public extraWorkDays: ExtraWorkDayHoliday[] = [];

}

export class ExtraWorkDayHoliday {

    public id: number;
    public date: string;
    public isHoliday: boolean;
    public desc: string;

}